// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uQOm","largestCol":"styles_largestCol__rgNjS","smallestCol":"styles_smallestCol__1ZQ4S"};